import Vue from 'vue'
import Router from 'vue-router'
import index from '../pages/Index.vue'
import whole from '../pages/Whole.vue'
import article from '../pages/Article.vue'
import special from '../pages/Special.vue'

Vue.use(Router)
//定义路由 
var router = new Router({
    routes:[
        {path: '/', redirect: '/index/whole'},
        {path: '/index', name:'index', component:index, meta: { title: '广东房地产网'} ,children:[
            {path: '/index/whole', name:'whole', component:whole, meta: { title: '广东房地产网'}},
            {path: '/index/article', name:'article', component:article, meta: { title: '广东房地产网'}},
        ]},
        {path: '/special', name:'special',component:special,meta:{title: '广东房地产网'}}
    ],
})

router.beforeEach((to, from, next)=>{
    if(to.meta.title){
      document.title = to.meta.title
    }
    next()
  })

export default router